<mat-tab-group (selectedTabChange)="change($event)" #tab>
  <mat-tab label="Ranks">
<mat-toolbar color="warn" style="height: 40px;">
  <span class="example-spacer"></span>
    <mat-select style="height: 10px;" [formControl]="rankControl" placeholder="Select rank">
    <mat-option *ngFor="let rank of ranks" [value]="rank">
      {{rank.name}}
    </mat-option>
  </mat-select>
</mat-toolbar>
  </mat-tab>
  <mat-tab label="Roles">
    <mat-toolbar color="warn" style="height: 40px;">
      <span class="example-spacer"></span>
      <mat-select style="height: 10px;" [formControl]="entitleControl" placeholder="Select role">
        <mat-option *ngFor="let e of roles" [value]="e">
          {{e.name}}
        </mat-option>
      </mat-select>
    </mat-toolbar>
  </mat-tab>
</mat-tab-group>
<table *ngIf="players.length > 0" mat-table [dataSource]="players">
  <ng-container matColumnDef="player">
    <th mat-header-cell *matHeaderCellDef>Player</th>
    <td mat-cell *matCellDef="let p">
      <span style="display: flex; align-items: center">
        <img src="https://mc-heads.net/avatar/{{p.uuid}}/20"> &nbsp;
        {{p.username}}
      </span>
    </td>
  </ng-container>
  <ng-container matColumnDef="uuid">
    <th mat-header-cell *matHeaderCellDef>UUID</th>
    <td mat-cell *matCellDef="let p">
      {{p.uuid}}
    </td>
  </ng-container>
  <ng-container matColumnDef="rank">
    <th mat-header-cell *matHeaderCellDef>Rank</th>
    <td mat-cell *matCellDef="let p">
      {{getRankName(p)}}
    </td>
  </ng-container>
  <ng-container matColumnDef="entitlements">
    <th mat-header-cell *matHeaderCellDef>Roles</th>
    <td mat-cell *matCellDef="let p">
      {{getRolesForPlayer(p)}}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns" routerLink="/players/{{row.uuid}}"></tr>
</table>
